import { get, del, post } from '../../client/utils/data';

export function handleError(api, key, err) {
  const biData = { integrationType: key };
  api.openErrorModal(biData);
  console.error(`Error getting mailchimp data ${err}`);
}

export function getInstance(api) {
  return api
    .getIntegrationInstance()
    .then((instance) => (instance ? instance : api.installTpa()));
}

export function getConfigedAxiosFunctions(apiBaseUrl, instance) {
  const config = { apiBaseUrl, instance };
  return {
    getData: get(config),
    deleteData: del(config),
    postData: post(config),
  };
}
